import { useTheme } from '../theme/ThemeProvider';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      // The label says what pressing it does, which is what a screen reader user needs, rather
      // than describing the icon.
      aria-label={`Switch to ${next} theme`}
      title={`Switch to ${next} theme`}
      className="rounded-md p-2 text-text-muted transition-colors hover:bg-surface-raised hover:text-text"
    >
      <span aria-hidden="true" className="text-base leading-none">
        {theme === 'dark' ? '☾' : '☀'}
      </span>
    </button>
  );
}
